


















import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import SearchBillContent from "@/modules/searchbilllading/List/SearchBillLading/index.vue";

@Component({
    name: "SearchBill",
    components: {SearchBillContent}
})
export default class extends mixins(CommonMixin) {
    visible = false;
    ladingCode = "";
    billLadings = [] as any;
    siteNote = "";
}
